
<!--
 * @Author: guoguo ybbhai@hotmail.com
 * @Date: 2023-09-25 16:26:30
 * @LastEditors: guoguo ybbhai@hotmail.com
 * @LastEditTime: 2023-11-24 11:16:49
 * @FilePath: \web\src\components\page\telephone.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <globalTitle />
    <el-card class="card">
      <div class="max">
        <div class="left">
          <el-card style="" class="img">
            <p>微信公众号</p>
            <img src="../../assets/images/gongZhongHao.jpg" alt="" />
          </el-card>
          <el-card style="" class="img">
            <!-- <p>新浪微博</p>
            <img src="../../assets/images/weiBo.jpg" alt="" /> -->
          </el-card>
        </div>
        <div class="right">
          <el-table :data="tableData" border :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
            <!-- :header-cell-style="{textAlign: 'center'}"设置头部居中： -->
            <!-- :cell-style="{ textAlign: 'center' }"设置整个表格内容水平居中： -->
            <el-table-column prop="serial" label="序号" width="60"> </el-table-column>
            <el-table-column prop="name" label="姓名"> </el-table-column>
            <el-table-column prop="post" label="职务" width=""> </el-table-column>
            <el-table-column prop="birthday" label="出生日期"> </el-table-column>
            <el-table-column prop="gender" label="性别" :formatter="formatSex"> </el-table-column>
            <!-- <el-table-column prop="phone" label="联系电话"> </el-table-column>
            <el-table-column prop="email" label="邮箱" width="200"> </el-table-column> -->
          </el-table>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import globalTitle from '../globalTitle.vue'
import { getStaffList } from '@/api/staff.js';

export default {
  components: { globalTitle },
  name: 'telephone',
  data() {
    return {
      queryParams: {
        pageSize: 10,
        total: 10,
        currentPage: 1
      },
      tableData: []
    }
  },
  mounted() {
    this.search();
  },
  methods: {
    formatSex(row) {
      return row.gender === 0 ? "男" : "女";
    },
    search () {
      getStaffList(this.queryParams).then(res => {
        if (res.code == 200) {
          this.tableData = res.data.records;
          this.queryParams.total = res.data.total;
          this.queryParams.currentPage = res.data.current;
          this.queryParams.pageSize = res.data.size;
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.card {
  margin-top: 10px;
}
.max {
  display: flex;
  justify-content: space-between;
}
p {
  text-align: center;
}
.right {
  width: 800px;
}
.left {
  width: 200px;
}
.img {
  display: flex;
  width: 320px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    height: 160px;
    width: 160px;
    display: block;
  }
}
</style>
